const BASE_URL = process.env.REACT_APP_BASE_URL

// AUTH ENDPOINTS
export const endpoints = {
  SENDOTP_API: BASE_URL + "/auth/sendotp",
  SIGNUP_API: BASE_URL + "/auth/signup",
  LOGIN_API: BASE_URL + "/auth/login",
  RESETPASSTOKEN_API: BASE_URL + "/auth/reset-password-token",
  RESETPASSWORD_API: BASE_URL + "/auth/reset-password",
}

// PROFILE ENDPOINTS
export const profileEndpoints = {
  GET_USER_DETAILS_API: BASE_URL + "/profile/getUserDetails",
  GET_USER_ENROLLED_COURSES_API: BASE_URL + "/profile/getEnrolledCourses",
  GET_INSTRUCTOR_DATA_API: BASE_URL + "/profile/instructorDashboard",
}

// STUDENTS ENDPOINTS
export const studentEndpoints = {
  COURSE_PAYMENT_API: BASE_URL + "/payment/capturePayment",
  COURSE_VERIFY_API: BASE_URL + "/payment/verifyPayment",
  SEND_PAYMENT_SUCCESS_EMAIL_API: BASE_URL + "/payment/sendPaymentSuccessEmail",
}

// COURSE ENDPOINTS
export const courseEndpoints = {
  GET_ALL_COURSE_API: BASE_URL + "/course/getAllCourses",
  COURSE_DETAILS_API: BASE_URL + "/course/getCourseDetails",
  EDIT_COURSE_API: BASE_URL + "/course/editCourse",
  COURSE_CATEGORIES_API: BASE_URL + "/course/showAllCategories",
  CREATE_COURSE_API: BASE_URL + "/course/createCourse",
  CREATE_SECTION_API: BASE_URL + "/course/addSection",
  CREATE_SUBSECTION_API: BASE_URL + "/course/addSubSection",
  UPDATE_SECTION_API: BASE_URL + "/course/updateSection",
  UPDATE_SUBSECTION_API: BASE_URL + "/course/updateSubSection",
  GET_ALL_INSTRUCTOR_COURSES_API: BASE_URL + "/course/getInstructorCourses",
  DELETE_SECTION_API: BASE_URL + "/course/deleteSection",
  DELETE_SUBSECTION_API: BASE_URL + "/course/deleteSubSection",
  DELETE_COURSE_API: BASE_URL + "/course/deleteCourse",
  GET_FULL_COURSE_DETAILS_AUTHENTICATED:
    BASE_URL + "/course/getFullCourseDetails",
  LECTURE_COMPLETION_API: BASE_URL + "/course/updateCourseProgress",
  CREATE_RATING_API: BASE_URL + "/course/createRating",
  CREATE_CATEGORY_API: BASE_URL + "/course/createCategory",
   GET_CATEGORIES_API: BASE_URL + "/course/showAllCategories",
  UPDATE_CATEGORY_API : BASE_URL + "/course/updateCategory", // Update category endpoint
  DELETE_CATEGORY_API : BASE_URL + "/course/deleteCategory", // Delete category endpoint
  ADD_COURSE_TO_CATEGORY_API: BASE_URL + "/course/addCourseToCategory",
 SEARCH_COURSES_API: BASE_URL + "/course/searchCourse",
}


export const notesEndpoints = {
  CREATE_NOTES_API: BASE_URL + "/notes/createNotes",
  EDIT_NOTES_API: BASE_URL + "/notes/editNotes",
  GET_NOTES_API: BASE_URL + "/notes/getAllNotes",
  DELETE_NOTES_API: BASE_URL + "/notes/deleteNotes",
  NOTES_CATEGORIES_API: BASE_URL + "/notes/getAllNotesCategory",
  NOTES_CATALOGPAGEDATA_API: BASE_URL + "/notes/notesCategoryPageDetails",
  GET_INSTRUCTOR_NOTES_API: BASE_URL + "/notes/getInstructorNotes",
  GET_SINGLE_NOTES_API: BASE_URL + "/notes/getSingleCourseDetails",
  GET_FULL_NOTES_DETAILS: BASE_URL + "/notes/getFullNotesDetails",
  CREATE_NOTES_CATEGORY_API: BASE_URL + "/notes/createNotesCategory", // Create category
  UPDATE_NOTES_CATEGORY_API: BASE_URL + "/notes/updateNotesCategory", // Update category
  DELETE_NOTES_CATEGORY_API: BASE_URL + "/notes/deleteNotesCategory", // Delete category
}


// RATINGS AND REVIEWS
export const ratingsEndpoints = {
  REVIEWS_DETAILS_API: BASE_URL + "/course/getReviews",
}

// CATAGORIES API
export const categories = {
  CATEGORIES_API: BASE_URL + "/course/showAllCategories",
   NOTES_CATEGORIES_API: BASE_URL + "/notes/getAllNotesCategory",
  
}

// CATALOG PAGE DATA
export const catalogData = {
  CATALOGPAGEDATA_API: BASE_URL + "/course/getCategoryPageDetails",
  NOTES_CATALOGPAGEDATA_API: BASE_URL + "/notes/notesCategoryPageDetails",
}
// CONTACT-US API
export const contactusEndpoint = {
  CONTACT_US_API: BASE_URL + "/reach/contact",
}

// SETTINGS PAGE API
export const settingsEndpoints = {
  UPDATE_DISPLAY_PICTURE_API: BASE_URL + "/profile/updateDisplayPicture",
  UPDATE_PROFILE_API: BASE_URL + "/profile/updateProfile",
  CHANGE_PASSWORD_API: BASE_URL + "/auth/changepassword",
  DELETE_PROFILE_API: BASE_URL + "/profile/deleteProfile",
}
